import { ClearablePill } from "components/Atoms/ClearablePill";
import React from "react";

interface Props {
  fullName: string
  downloadUrl: string
  onClear?: () => void
}

const FileTag = ({ fullName, downloadUrl, onClear }: Props) => {
  const extensionIndex = fullName.lastIndexOf(".");
  const name = extensionIndex === -1 ? fullName : fullName.substring(0, extensionIndex);
  const extension = fullName.substring(name.length);
  const fileName = name.length > 25
    ? name.substr(0, 21) + "… " + extension
    : fullName;

  return <ClearablePill color="blue" onClear={onClear}>
    <a title={fullName} download href={downloadUrl}>{fileName}</a>
  </ClearablePill>;
};

export default FileTag;
